import * as React from "react";
import { QueryRenderer, graphql } from "react-relay";

import Bugsnag from "~/lib/Bugsnag";
import Environment from "~/lib/relay/environment";

import Spinner from "~/components/shared/Spinner";

import JobLogExitInformation from "~/components/job/Job/Log/ExitInformation/JobLogExitInformation";

type Props = {
  job: {
    id: string;
  };
};

type QueryRendererData = {
  error: Error | null | undefined;
  props: any;
};

export default class JobLogExitInformationWrapper extends React.PureComponent<Props> {
  environment = Environment.get();
  static displayName = "JobLogExitInformationWrapper";

  static query = graphql`
    query ExitInformationWrapperQuery($id: ID!) {
      job(uuid: $id) {
        ...JobLogExitInformation_job
      }
    }
  `;

  renderQuery = ({ error, props }: QueryRendererData) => {
    const { job: _job, ...wrapperProps } = this.props;

    if (error) {
      Bugsnag.notify(error);
      return null; // TODO: Handle this!
    }

    if (!props) {
      return <Spinner />;
    }

    return <JobLogExitInformation {...wrapperProps} {...props} />;
  };

  render() {
    return (
      <QueryRenderer
        fetchPolicy="store-and-network"
        cacheConfig={{ force: true }}
        environment={this.environment}
        query={JobLogExitInformationWrapper.query}
        variables={{ id: this.props.job.id }}
        render={this.renderQuery}
      />
    );
  }
}
